import { render } from "./RequestMx.vue?vue&type=template&id=60535dae&scoped=true"
import script from "./RequestMx.vue?vue&type=script&lang=js"
export * from "./RequestMx.vue?vue&type=script&lang=js"

import "./RequestMx.vue?vue&type=style&index=0&id=60535dae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60535dae"]])

export default __exports__